<ng-container *transloco="let t">
    <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative">
            <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user?.avatar" [src]="user?.avatar">
            <mat-icon *ngIf="!showAvatar || !user?.avatar" svgIcon="heroicons_outline:user-circle"></mat-icon>
            <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user?.avatar,
                          'bg-green-500': user?.status === 'online',
                          'bg-amber-500': user?.status === 'away',
                          'bg-red-500': user?.status === 'busy',
                          'bg-gray-400': user?.status === 'not-visible'}"></span>
        </span>
    </button>

    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <!-- <button mat-menu-item>
            <span class="flex flex-col leading-none">
                <span class="mt-1.5 text-md font-medium">{{app?.credential?.user?.name}}</span>
                <span class="mt-1.5 text-sm font-medium text-secondary">{{app?.credential?.accessId}}</span>
            </span>
        </button>
        <mat-divider class="my-2"></mat-divider> -->
        <button mat-menu-item>
            <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
            <div class="flex flex-col gap-0.5">
                <span class="text-md leading-none font-medium">{{app?.credential?.user?.name}}</span>
                <span
                    class="text-sm leading-none font-medium text-secondary w-40 break-words">{{app?.credential?.accessId}}</span>
            </div>
        </button>


        <button mat-menu-item (click)="resetPassword()">
            <mat-icon svgIcon="mat_outline:password"></mat-icon>
            <span>{{t('Update Password')}}</span>
        </button>
        <!--
				<mat-menu #userMenu="matMenu">
					<button mat-menu-item (click)="resetPassword()">
							<mat-icon class="icon-size-5" svgIcon="mat_outline:password"></mat-icon>
							<span>{{t('Update Password')}}</span>
					</button>

			</mat-menu> -->


        @if(config.scheme === 'dark'){
        <button mat-menu-item [matMenuTriggerFor]="mode">
            <mat-icon svgIcon="heroicons_solid:moon" class="icon-size-5"></mat-icon>
            <span>{{t('Mode Dark')}}</span>
        </button>
        }

        @if(config.scheme === 'light'){
        <button mat-menu-item [matMenuTriggerFor]="mode">
            <mat-icon svgIcon="heroicons_solid:sun"></mat-icon>
            <span>{{t('Mode Light')}}</span>
        </button>
        }

        @if(config.scheme === 'auto'){
        <button mat-menu-item [matMenuTriggerFor]="mode">
            <mat-icon svgIcon="heroicons_solid:bolt"></mat-icon>
            <span>{{t('Mode Auto')}}</span>
        </button>
        }


        <mat-menu #mode="matMenu">
            <button mat-menu-item (click)="setScheme('dark')">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:moon'"></mat-icon>
                <span>{{t('Dark')}}</span>
            </button>

            <button mat-menu-item (click)="setScheme('light')">
                <mat-icon [svgIcon]="'heroicons_solid:sun'"></mat-icon>
                <span>{{t('Light')}}</span>
            </button>

            <button mat-menu-item (click)="setScheme('auto')">
                <mat-icon [svgIcon]="'mat_outline:bolt'"></mat-icon>
                <span>{{t('Auto')}}</span>
            </button>


        </mat-menu>

        <!--
        <button mat-menu-item (click)="app.openSettings.next();">
            <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
            <span>{{t('Settings')}}</span>
        </button> -->
        <!-- <button mat-menu-item [matMenuTriggerFor]="userStatus">
            <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
            <span>Status</span>
        </button> -->
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="signOut()">
            <mat-icon svgIcon="mat_outline:logout"></mat-icon>
            <span>{{t('Sign out')}}</span>
        </button>
    </mat-menu>

    <!-- <mat-menu class="user-status-menu" #userStatus="matMenu">
        <button mat-menu-item (click)="updateUserStatus('online')">
            <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
            <span>Online</span>
        </button>
        <button mat-menu-item (click)="updateUserStatus('away')">
            <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
            <span>Away</span>
        </button>
        <button mat-menu-item (click)="updateUserStatus('busy')">
            <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
            <span>Busy</span>
        </button>
        <button mat-menu-item (click)="updateUserStatus('not-visible')">
            <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
            <span>Invisible</span>
        </button>
    </mat-menu> -->
</ng-container>